import { getDitricts } from '@/modules/Employee/services'
import { FilterSelect } from '@/components/ui/filters'
import { useQuery } from '@tanstack/react-query'
import { FieldValues, Path, UseFormReturn } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { QUERY_KEYS } from '@/constants/reactQueryKeys'

interface DistrictSelectProps<T extends FieldValues> {
    state: string
    control: UseFormReturn<T, any, any>['control']
    name: Path<T>
    multiple?: boolean
    disabled?: boolean
    label?: string
    onChangeAfterHookForm?: () => void
}

const DistrictSelect = <T extends FieldValues>({
    state,
    control,
    name,
    multiple,
    label,
    disabled = false,
    onChangeAfterHookForm,
}: DistrictSelectProps<T>) => {
    const { data: districts } = useQuery({
        queryKey: [QUERY_KEYS.DISTRICTS, state],
        queryFn: () => getDitricts(state),
        enabled: !!state,
    })
    const { t } = useTranslation()
    return (
        <FilterSelect
            control={control}
            name={name}
            label={t(label || 'district')}
            placeholder={t(label || 'district')}
            options={districts || []}
            showClearButton={false}
            disabled={disabled}
            multiple={multiple}
            onChangeAfterHookForm={onChangeAfterHookForm}
        />
    )
}

export default DistrictSelect
